module.exports = __webpack_public_path__ + "img/404.0411f9fb.png";